<template>
  <v-card-text class="py-0">
    <v-row v-if="booking">
      <v-col cols="12" xs="10" sm="10">
        <v-row>
          <v-col cols="12" md="3" class="body-2">
            <h4>
              <router-link :to="'/trip/' + booking._id">
                {{booking.title }}
              </router-link >
            </h4>
            <br />
            <router-link :to="'/trip/' + booking._id"
              ><h5>{{ booking.tripNo }}</h5></router-link
            >
            <p v-if="booking.clientName != null">
              <i class="fa fa-university"></i>
              {{ booking.clientName }}
            </p>
            <p title="Status" v-if="booking.statusStr">
                <v-icon style="color: blue">mdi-exclamation</v-icon>
                {{ booking.statusStr }}
            </p>
            <p v-if="booking.verified"><v-icon>mdi-check</v-icon> Verified</p>
            <!-- <p v-if="booking.clientInvoice_id != null">
              <a
                :to="'/sales/invoice/' + booking.clientInvoice_id"
                target="_blank"
              >
                <b>Client Invoiced</b>
              </a>
            </p> -->
            <!-- <p v-if="booking.supplierInvoice_id != null">
              <a
                :to="'/sales/invoice/' + booking.supplierInvoice_id"
                target="_blank"
              >
                <b>Supplier Invoiced</b>
              </a>
            </p> -->
            <!-- <p v-if="booking.lrNos">
              <i class="fa fa-sticky-note" style="color: green"></i>
              {{ booking.lrNos }}
            </p> -->
            <!-- <p v-if="booking.cargos && booking.cargos.length>0 && booking.cargos[0].lr">
              LR: {{ booking.cargos[0].lr.number }}
            </p> -->
            <p v-if="booking.lrNos">
              LR: {{ booking.lrNos }}
            </p>
            <p v-if="booking.goodsInvNos">
              Goods Invoice No.: {{ booking.goodsInvNos }}
            </p>
            <p v-if="booking.clientLrNos">
              Client LR: {{ booking.clientLrNos }}
            </p>
            <p>{{ booking.fare.currency + " " + booking.clientSubtotal?booking.clientSubtotal:booking.fare.subtotal }}</p>
          </v-col>

          <v-col cols="12" md="9" class="body-2">
            <div style="display: inline-flex; margin-bottom: -7px">
              <p title="Start Time">
                <i class="fa fa-calendar" style="color: green"></i>
                {{ booking.startTime | moment("DD MMM YYYY hh:mm a") }}
              </p>
              <p title="End Time">
                <i class="fa fa-calendar" style="color: red"></i>
                {{ booking.endTime | moment("DD MMM YYYY hh:mm a") }}
              </p>
            </div>
            <p style="border-bottom: 1px solid #dfdfdf; margin-bottom: 3px"></p>
            <div>
              <p title="Source Address" v-if="booking.src">
                <v-icon style="color: green">mdi-map-marker</v-icon>
                {{ booking.src.addressLine }}, {{ booking.src.city }}
              </p>
              <p title="Destination Address" v-if="booking.dst">
                <v-icon style="color: red">mdi-map-marker</v-icon>
                {{ booking.dst.addressLine }},
                {{ booking.dst.city }}
              </p>
            </div>
            <p
              style="border-bottom: 1px solid #dfdfdf; margin-bottom: 3px"
              v-if="booking.cargos"
            ></p>
            <div style="display: inline-flex; margin-bottom: -7px">
              <p v-if="booking.lrNos">
              <i class="fa fa-sticky-note" style="color: green"></i>
              {{ booking.lrNos }}
            </p>
            </div>
            <p
              style="border-bottom: 1px solid #dfdfdf; margin-bottom: 3px"
              v-if="
                booking.vehicle != null && booking.vehicle.vehicleType != null
              "
            ></p>
            <div
              style="display: inline-flex; margin-bottom: -7px"
              v-if="
                booking.vehicle != null && booking.vehicle.truckTypeStr != null
              "
            >
              <p title="Vehicle">
                <v-icon>mdi-car</v-icon>
                {{ booking.vehicle.truckTypeStr }} ({{ booking.vehicle.regNo }})
              </p>
              <p
                v-if="booking.driver != null && booking.driver.name != null"
                title="Driver"
              >
                <v-icon>mdi-account</v-icon>
                {{ booking.driver.name }} ({{
                  "+" + booking.driver.countryCode
                }}
                {{ booking.driver.phone }})
              </p>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="2" class="body-2">
        <v-btn
          @click="addToSelected"
          v-if="!remove"
          fab
          text
          small
          color="success"
        >
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>
        <v-icon
          @click="removeFromSelected"
          v-if="remove"
          fab
          text
          small
          color="error"
          >mdi-close</v-icon
        >
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "BookingRow",
  props: {
    value: {
      default: null,
    },
    remove: {
      default: false,
    },
  },
})
export default class BookingRow extends Vue {
  booking = null;

  addToSelected() {
    this.$emit("addToSelected", this.booking);
  }

  removeFromSelected() {
    this.$emit("removeFromSelected", this.booking);
  }

  roundOffToTwoDecimal(num) {
    return Math.round(num * 100) / 100;
  }

  mounted() {
    if (this.value) {
      this.booking = this.value;
    }
  }

  @Watch("value")
  onValueChange(val) {
    this.booking = val;
  }
}
</script>
